import { useState } from "react";
import axios, { AxiosError } from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

interface Withdrawals {
  amount: string;
  transactions: string[];
  stp_date: {
    name: string;
    account_number: string;
    type_of_account: string;
    code_bank: string;
  };
}

interface CreateWithdrawalResponse {
  data: {
    message?: string;
    success: any; // puedes tiparlo mejor si sabes la estructura
  };
}

const useCreateWithdrawals = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const createWithdrawals = async (token: any, requestBody: Withdrawals) => {
    setLoading(true);
    setError(null);
    setData(null);

    try {
      const tk = await getAccessTokenSilently();

      const response = await axios.post<CreateWithdrawalResponse>(
        `${apiUrl}/api/v1/withdrawaltransaction/create`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tk}`,
          },
        }
      );

      const responseData = response.data.data;

      setData(responseData);
      return responseData;
    } catch (err: unknown) {
      if (axios.isAxiosError(err)) {
        setError(err.response?.data?.message || "Error en la petición");
      } else {
        setError("Error inesperado al crear el retiro");
      }
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setData(null);
    setError(null);
    setLoading(false);
  };

  return { data, loading, error, createWithdrawals, reset };
};

export default useCreateWithdrawals;
